export default __webpack_public_path__ + "static/formes-associations-11bdcd18be8939a0b08c021f678b3606.png";